import React from 'react';
import { Image as ImageIcon, AlertCircle } from 'lucide-react';
import ImageBrowser from '../../shared/ImageBrowser';
import { useSetDefaultImage } from '../../../services/userImageService';
import { useAuth } from '../../../contexts/AuthContext';

const ImagesTab = () => {
  const { updateUser } = useAuth();

  const setDefaultImageMutation = useSetDefaultImage({
    onSuccess: async (data) => {
      try {
        const response = await fetch('/api/vendor/profile', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            image_url: data.data.image_url
          })
        });
        
        if (response.ok) {
          const updatedUser = await response.json();
          updateUser(updatedUser.data);
        }
      } catch (error) {
        console.error('Failed to update vendor profile image:', error);
      }
    }
  });

  const handleImageSelect = async (image) => {
    if (image) {
      setDefaultImageMutation.mutate(image.id);
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div>
        <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">Manage Images</h3>
        <p className="text-sm text-gray-600">
          Upload and manage your images. Select an image to use as your profile picture or business image.
        </p>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 sm:p-6 mb-4 sm:mb-6">
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
          <div className="min-w-0">
            <h4 className="text-sm font-medium text-blue-900">Image Guidelines</h4>
            <ul className="text-sm text-blue-700 mt-1 space-y-1 list-disc list-inside">
              <li>Supported formats: JPEG, PNG, GIF, WebP</li>
              <li>Maximum file size: 10MB</li>
              <li>Recommended dimensions: 1200x800px or larger</li>
              <li>Click on an image to select it as your profile/business image</li>
            </ul>
          </div>
        </div>
      </div>

      <ImageBrowser
        imageType="profile"
        onSelectImage={handleImageSelect}
        showUpload={true}
        showDelete={true}
        showSetDefault={false}
      />
    </div>
  );
};

export default ImagesTab;

